import Modal from 'antd/lib/modal'
import Button from 'antd/lib/button'
import Flex from 'antd/lib/flex'
import type { DeviceRecoveryFailureReason, ProctoringBlockerType } from 'proctoring-sdk/index'
import { getProctoringBlockerContent } from './proctoringBlockerContent'
import styles from './ProctoringBlockerModal.module.less'

interface ProctoringBlockerModalProps {
    blocker: ProctoringBlockerType | null
    checking: boolean
    lastFailureReason: DeviceRecoveryFailureReason | null
    deniedDevices?: Array<ProctoringBlockerType.Webcam | ProctoringBlockerType.Microphone> | null
    exitLabel: string
    onCheckAgain: () => void
    onExitRequested?: () => void
}

export const ProctoringBlockerModal = ({
    blocker,
    checking,
    lastFailureReason,
    deniedDevices,
    exitLabel,
    onCheckAgain,
    onExitRequested,
}: ProctoringBlockerModalProps) => {
    if (!blocker) return null

    const content = getProctoringBlockerContent(blocker, deniedDevices)
    const failureHint = lastFailureReason ? content.failureHints[lastFailureReason] : undefined

    return (
        <Modal
            open
            centered
            closable={false}
            maskClosable={false}
            keyboard={false}
            footer={null}
            width={400}
            rootClassName={styles.blockerModal}
            data-testid="proctoring-blocker-modal"
        >
            <Flex vertical gap={16}>
                <Flex align="center" justify="center" className={styles.iconCircle}>
                    {content.icon}
                </Flex>
                <Flex vertical gap={4}>
                    <h3>{content.title}</h3>
                    <p>{content.message}</p>
                    {failureHint ? <p className={styles.failureHint}>{failureHint}</p> : null}
                </Flex>
                <Flex vertical gap={8}>
                    <Button
                        block
                        type="primary"
                        icon={content.primaryIcon}
                        iconPosition="end"
                        loading={checking}
                        onClick={onCheckAgain}
                        data-testid="proctoring-blocker-primary-action"
                    >
                        {content.primaryLabel}
                    </Button>
                    <Button
                        block
                        type="default"
                        disabled={checking}
                        onClick={onExitRequested}
                        data-testid="proctoring-blocker-exit"
                    >
                        {`Exit ${exitLabel}`}
                    </Button>
                </Flex>
            </Flex>
        </Modal>
    )
}
